import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { ConstantActions, LeadFormActions } from '../../../Services/_actions';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Grid,
  Typography,
  Button,
  Popover,
  FormControlLabel,
  Checkbox,
  IconButton,
  MenuItem,
  Menu,
  CircularProgress,
  Stack,
  Divider,
  LinearProgress,
  Dialog,
  DialogContent,
} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import FilterListIcon from '@mui/icons-material/FilterList';
import EditIcon from '@mui/icons-material/Edit';
import AssessmentIcon from '@mui/icons-material/Assessment';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import {
  campaignDataMapAtom,
  campaignLeadManagementAtom,
  leadsTableStateAtom,
  userInformationAtom,
} from '../../../Services/_states/index.js';
import {
  fetchLeadData,
  leadsActionSelector,
} from '../../../Services/_states/Leads/leadSelector.ts';
import {
  convertToReadableFormat,
  dateFormate,
  isValidNumber,
  indianTimeZone,
  renderToolTip,
} from '../../../utils/helper.jsx';
import CommonTable, { EllipsisWithTooltip } from '../../Shared/Tables/TableV1.tsx';
import ViewCommentModal from '../ViewCommentModal.tsx';
import FormDetailsModal from '../FormDetailsModal.tsx';
import ViewImagesModal from '../ViewImagesModal.tsx';
import AllUpdateStatusModal from '../AllUpdatedStatusModal.tsx';
import { MRT_SortingState } from 'material-react-table';
import { useSnackBar } from '../../FlowBuilder/Common/SnackBar/index.tsx';
import DynamicFilters from '../DynamicFilters.tsx';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useResetRecoilState } from 'recoil';
import ConfirmBox from '../../FlowBuilder/Common/ConfirmBox/index.tsx';
import {
  getColumnVisibilityFromFormObject,
  staticLeadTableColumns,
  updateDataWithFieldPermissions,
  updateFormObjectForColumnVisibility,
} from '../DynamicFormFields/helper.ts';
import { CallingModal } from '../../Modals/CallingModal/CallingModal.jsx';
import ModalForms from '../../Shared/Modals/index.js';
import AIChatModal from '../AIChatModal.tsx';
import { AiActions } from '../../../Services/_actions/Ai/ai.actions.ts';
import AudioSummaryModal from '../AudioSummaryModal.tsx';
import AssignLeadsModal from '../AssignLeadsModal.tsx';
import { Email as EmailIcon, Phone as PhoneIcon } from '@mui/icons-material';
import CommonBadges from '../../Shared/Badges/index.jsx';
import ManageActionModal from './ManageActionModal.tsx';
import { globalpermissions } from '../../../Services/Permission.js';
import AssignmentLogsModal from './AssignmentLogsModal.tsx';
import DescriptionIcon from '@mui/icons-material/Description';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import DeleteIcon from '@mui/icons-material/Delete';
import InsertCommentIcon from '@mui/icons-material/InsertComment';
import StatusDropdown from '../../Shared/StatusDropdown/StatusDropdown.tsx';
import Reports from './Reports.tsx';
import Analytics from './Analytics.tsx';
import HelpFile from './HelpFile.tsx';
import useDebounce from '../../Shared/Delay/index.tsx';
import SearchBox from '../../FlowBuilder/Common/SearchBox/index.tsx';
import { UIEvent } from 'react';
import ToolBar from './ToolBar.tsx';
import DateRangeFilter from '../../Shared/DateRangeFilter/DateRangeFilter.tsx';
import EntityDetailsDropdown from '../../Shared/EntityDropdown/EntityDetailsDropdown.tsx';

const defaultVisibleColumns = [
  'lead_id',
  'phone_number',
  'created_at',
  'last_machadalo_comment.comment',
  'audio_summary',
  'aichat',
];
const LeadList = () => {
  const loggedInUser = useRecoilValue(userInformationAtom);
  const profileId = loggedInUser?.profile?.id;
  const navigate = useNavigate();
  const aiActions = AiActions();
  const leadActions = LeadFormActions();
  const constantActions = ConstantActions();
  const [tableState, setTableState] = useRecoilState<any>(leadsTableStateAtom);
  const setLeadActions = useSetRecoilState(leadsActionSelector);
  const campaignLeadManagementData = useRecoilValue(campaignLeadManagementAtom);
  const statusList =
    campaignLeadManagementData?.statusData?.[
    campaignLeadManagementData?.selectedForm?.leads_form_id
    ] ?? [];
  const campaignFormCount = campaignLeadManagementData?.selectedCampaign?.proposal_id
    ? campaignLeadManagementData?.[campaignLeadManagementData?.selectedCampaign?.proposal_id]
      ?.length
    : 0;
  const [openCommentModal, setOpenCommentModal] = useState(false);
  const [openFormDetailModal, setOpenFormDetailModal] = useState(false);
  const [openImageModal, setOpenImageModal] = useState(false);
  const [openUpdateStatusModal, setOpenUpdateStatusModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const { showSnackBar } = useSnackBar();
  const [filterableFields, setFilterableFields] = useState<any>([]);
  const [dynamicFormGroups, setDynamicFormGroups] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [confirmStatusOpen, setConfirmStatusOpen] = useState(false);
  const [confirmDateOpen, setConfirmDateOpen] = useState(false);
  const [statusDataToUpdate, setStatusDataToUpdate] = useState<{
    id: number;
    status?: string;
    status_id?: string;
    type_of_status?: string;
    status_name?: string;
    sub_status_id?: string;
    sub_status_name?: string;
  } | null>(null);
  const [pendingDateUpdate, setPendingDateUpdate] = useState<{ id: number; date: string } | null>(
    null
  );
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [showCallingModal, setShowCallingModal] = useState(false);
  const resetCampaignDataMap = useResetRecoilState(campaignDataMapAtom);
  const [openAIChatModal, setOpenAIChatModal] = useState(false);
  // const [selectedAIChatData, setSelectedAIChatData] = useState<
  //   { input: string; output: string; datetime?: string }[]
  // >([]);
  const [openSummaryModal, setOpenSummaryModal] = useState(false);
  const [summaryRowData, setSummaryRowData] = useState<any>(null);
  const [dataList, setDataList] = useState();
  const [selectedLeads, setSelectedLeads] = useState({});
  const [isLeadAssignModalOpen, setIsLeadAssignModalOpen] = useState(false);
  const [unAssignModalOpen, setUnAssignModalOpen] = useState(false);
  const [openEditLeadModal, setOpenEditLeadModal] = useState(false);
  const [anchorElAction1, setAnchorElAction1] = useState<null | HTMLElement>(null);
  const [openAssignmentLogs, setOpenAssignmentLogs] = useState(false);
  const [assignmentLogsData, setAssignmentLogsData] = useState<any[]>([]);
  const campaignId = campaignLeadManagementData?.selectedCampaign?.proposal_id;
  const leadFormId = campaignLeadManagementData?.selectedForm?.leads_form_id;
  const [openReportsModal, setOpenReportsModal] = useState(false);
  const [openAnalyticsModal, setOpenAnalyticsModal] = useState(false);
  const [openHelpModal, setOpenHelpModal] = useState(false);
  const [filtersAnchorEl, setFiltersAnchorEl] = useState(null);
  const [menuAnchorEl, setMenuAnchorEl] = React.useState<null | HTMLElement>(null);
  const [menuRow, setMenuRow] = React.useState<any>(null);
  const tableContainerRef = useRef<HTMLDivElement>(null);
  const lastScrollLeftRef = useRef<number>(0);
  const lastScrollTopRef = useRef<number>(0);
  const [selectedLeadId, setSelectedLeadId] = useState<string>('');
  const [selectedLeadCId, setSelectedLeadCId] = useState<string>('');
  const [dateRange, setDateRange] = useState({
    startDate: null,
    endDate: null,
  });
  const [openDownloadModal, setOpenDownloadModal] = useState(false);
  const [downloadColumnVisibility, setDownloadColumnVisibility] = useState<any>({});

  const buildEntityQueryParamsForRow = useCallback(
    (field: any, rowData: any) => {
      if (!Array.isArray(field?.query_parameter) || field.query_parameter.length === 0) return [];

      const formDataArr = rowData?.data ?? [];
      return field.query_parameter.map((param: any) => {
        const findValue =
          formDataArr?.find(
            (f: any) => f?.alias_name === param?.param || f?.key_name === param?.param
          ) ?? null;

        let paramValue: any = '';
        let entity_record_id = '';

        if (param?.param === 'global_phone_number') {
          paramValue = rowData?.phone_number || '';
        } else if (findValue?.entity_data && findValue?.entity_data?._id) {
          entity_record_id = findValue?.entity_data?._id ?? '';
          paramValue = findValue?.value?.value ?? findValue?.value ?? '';
        } else {
          paramValue = findValue?.value ?? '';
        }

        return {
          matched_with: param?.matched_with || '',
          param: param?.param || '',
          ...(paramValue !== '' && paramValue !== null && paramValue !== undefined
            ? { paramValue }
            : {}),
          ...(entity_record_id ? { entity_record_id } : {}),
          ...(param?.entity_form_field ? { entity_form_field: param.entity_form_field } : {}),
          ...(findValue?.is_required ? { is_required: findValue?.is_required ?? false } : {}),
        };
      });
    },
    []
  );

  const buildLeadPayloadForEntityUpdate = useCallback(
    (rowData: any, updatedEntries: any[]) => {
      const payload: any = {
        area: rowData?.area || '',
        city: rowData?.city || '',
        lead_id: rowData?.lead_id || '',
        leads_form_entries: [],
        phone_number: rowData?.phone_number || '',
        supplier_id: rowData?.supplier_id || '',
        supplier_name: rowData?.supplier_name || '',
      };

      const entryList = (updatedEntries ?? []).map((item: any) => ({
        key_name: item?.key_name,
        value: item?.entity_data?.value ? item?.entity_data?.value ?? '' : item?.value ?? '',
        ...(item?.entity_data && { entity_data: item?.entity_data ?? null }),
        ...(item?.status_config && { status_config: item?.status_config ?? null }),
      }));

      payload.leads_form_entries = entryList;
      payload.leads_form_id = isNaN(parseInt(leadFormId as any)) ? '' : parseInt(leadFormId as any);
      payload.parent_id = { lead_id: rowData?.parent_id?.lead_id || '' };

      return payload;
    },
    [leadFormId]
  );


  // const handleDateRangeApply = (range) => {
  //   setDateRange(range);

  //   const updatedFilters = {
  //     ...tableState.filters,
  //     start_date: range.startDate ? dateFormate(range.startDate, 'YYYY-MM-DD') : null,
  //     end_date: range.endDate ? dateFormate(range.endDate, 'YYYY-MM-DD') : null,
  //     offset: 0,
  //   };

  //   if (!range.startDate && !range.endDate) {
  //     delete updatedFilters.start_date;
  //     delete updatedFilters.end_date;
  //   }

  //   fetchLeads(updatedFilters);
  // };
  useEffect(() => {
    setDateRange({
      startDate: null,
      endDate: null,
    });
  }, [leadFormId]);

  const selectedRowsData = useMemo(() => {
    const ids = Object.keys(selectedLeads).filter(id => selectedLeads[id]);
    return tableState?.data?.filter(row => ids.includes(String(row.lead_id))) || [];
  }, [selectedLeads, tableState?.data]);

  useEffect(() => {
    setSelectedLeads({});

    setSelectedRow({});

    handleMenuClose();
  }, [campaignId, leadFormId]);

  const handleMenuOpen = (event, row) => {
    setMenuAnchorEl(event.currentTarget);
    setMenuRow(row.original);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
    setMenuRow(null);
  };

  const handleDownloadLeads = async () => {
    try {
      await leadActions.downloadLeadsByCampaignAndFormId(
        tableState?.filters,
        downloadColumnVisibility
      );
      showSnackBar('Download started!', 'success');
      setOpenDownloadModal(false);
    } catch (error) {
      showSnackBar('Failed to download records', 'error');
    }
  };

  const handleOpenDownloadModal = () => {
    setDownloadColumnVisibility(columnVisibility);
    setOpenDownloadModal(true);
  };

  const optionColorsByAlias = useMemo(() => {
    const items = campaignLeadManagementData?.selectedForm?.leads_form_items ?? {};
    const list = Array.isArray(items) ? items : Object.values(items);
    const map: Record<string, Record<string, string>> = {};
    list.forEach((fld: any) => {
      const alias = fld?.key_name;
      if (alias && fld?.option_colors) {
        map[alias] = fld.option_colors as Record<string, string>;
      }
    });
    return map;
  }, [campaignLeadManagementData?.selectedForm?.leads_form_items]);
  const [typeOfStatusList, setTypeOfStatusList] = useState<any>({});
  const [searchInput, setSearchInput] = useState('');
  const debouncedSearch = useDebounce(searchInput, 300); // 500ms delay
  // const hasActiveFilters =
  //   tableState.filters.dynamicFilters && tableState.filters.dynamicFilters.length > 0;
  const isValidDynamicRule = (rule: any) => {
    // empty / not_empty operator always active
    if (['empty', 'not_empty'].includes(rule?.operator)) return true;

    // STATUS
    if (rule?.param?.status_id) return true;

    // SUB STATUS
    if (rule?.param?.sub_status_id) return true;

    // NORMAL VALUE
    if (rule?.custom_value !== undefined) {
      if (Array.isArray(rule.custom_value)) return rule.custom_value.length > 0;
      return rule.custom_value !== '' && rule.custom_value !== null;
    }

    return false;
  };

  const hasActiveFilters =
    Array.isArray(tableState?.filters?.dynamicFilters) &&
    tableState.filters.dynamicFilters.some(isValidDynamicRule);


  const handleClick1 = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorElAction1(event.currentTarget);
  };
  const actionOpen1 = Boolean(anchorElAction1);
  const handleClose1 = () => {
    setAnchorElAction1(null);
  };

  const handleImport = () => {
    navigate(`/r/records/${campaignId}/importLeads/${leadFormId}`);
  };
  const handleOpenAIChatModal = (rowData) => {
    setSelectedLeadCId(rowData?.c_id || '');
    setSelectedRow(rowData);
    setOpenAIChatModal(true);
  };


  const handleRefresh = () => {
    try {
      fetchLeads({ ...tableState.filters, offset: 0 })
    } catch (error) {
      console.log(error, "error")
    } finally {
      if (tableContainerRef?.current) {
        tableContainerRef.current.scrollTo({ top: 0 });
      }
    }
  };

  function getParentStatusConfig(row: any, parentKey: string) {
    const item = row?.data?.find((d: any) => d?.key_name === parentKey);
    return item?.status_config || null;
  }
  const fetchLeads = async (tableStateFilters) => {
    try {
      setIsLoading(true);
      const response = await fetchLeadData(tableStateFilters);
      const existingData = tableState?.data || [];
      if (tableStateFilters?.offset === 0) {
        setTableState((prev) => ({ ...prev, ...response, filters: tableStateFilters }))
      } else {
        const { data: newPageData = [], ...restResponse } = response;
        setTableState((prev) => ({
          ...prev,
          ...restResponse,
          data: [...existingData, ...newPageData],
          filters: tableStateFilters
        }));
      }
    } catch (error) {
      console.warn(error, "error")
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    if (campaignLeadManagementData?.selectedForm?.leads_form_items) {
      const data = Object.values(campaignLeadManagementData?.selectedForm?.leads_form_items) ?? [];
      const updateDataWithPermissions = updateDataWithFieldPermissions(
        data,
        loggedInUser?.profile?.id ?? ''
      );
      // ensure static columns exist in the dynamic fields list
      const mergedFields = [...updateDataWithPermissions];
      Object.entries(staticLeadTableColumns).forEach(([staticKey, cfg]) => {
        const exists = mergedFields.some((f) => f?.key_name === (cfg?.key_name || staticKey));
        if (!exists) {
          mergedFields.push({ ...cfg });
        }
      });
      setFilterableFields(mergedFields);
      setDynamicFormGroups(campaignLeadManagementData?.selectedForm?.group_options ?? []);
    }
  }, [campaignLeadManagementData?.selectedForm?.leads_form_items, leadFormId, loggedInUser?.profile?.id]);

  const handleConfirmUpdate = async (confirmed: boolean) => {
    if (!confirmed || !statusDataToUpdate) {
      setConfirmStatusOpen(false);
      return;
    }
    try {
      const { id, status, type_of_status } = statusDataToUpdate;
      const res: any = await leadActions.updateLeadStatusDate(statusDataToUpdate);
      if (res?.status === 200) {
        const updatedData = (selectedRow?.data ?? [])?.map((item) => {
          if (item.key_name === type_of_status) {
            return {
              ...item,
              value: status,
              status_config: {
                ...statusDataToUpdate,
                name: statusDataToUpdate?.sub_status_name,
              },
            };
          }
          return item;
        })
        setLeadActions({ type: "update", payload: { ...selectedRow, data: updatedData } })
        showSnackBar('Current status updated successfully!', 'success');
      } else {
        showSnackBar('Failed to update current status.', 'error');
      }
    } catch (error) {
      showSnackBar('Error while updating current status.', 'error');
    } finally {
      setStatusDataToUpdate(null);
      setSelectedRow(null);
      setConfirmStatusOpen(false);
    }
  };
  const onCloseFormFieldsModal = (dynamicFormData, type = '') => {
    // if (type === 'update') {
    //   setLeadActions({ type: type, payload: { ...selectedRow, data: dynamicFormData } });
    // } else if (type === 'create') {
    //   handleRefresh();
    // }
    setOpenFormDetailModal(false);
  };

  const confirmDeleteLead = async (confirmed: boolean) => {
    if (confirmed && selectedRow) {
      try {
        const leadIds = Array.isArray(selectedRow)
          ? selectedRow.map((row) => row.lead_id)
          : [selectedRow.lead_id];

        const payload = {
          lead_ids: leadIds,
        };
        const res: any = await leadActions.deleteLeadV1(payload);
        if (res?.status === 200) {
          // setLeadActions({ type: "delete", payload: selectedRow })
          showSnackBar('Record deleted successfully!', 'success');
        } else {
          showSnackBar('Failed to delete record.', 'error');
        }
      } catch (error) {
        showSnackBar('Failed to delete record.', 'error');
      } finally {
        setSelectedRow(null);
      }
    }
  };

  const navigateToWebForm = (rowData) => {
    try {
      const phoneNumber = rowData?.phone_number;
      const campaignData = campaignLeadManagementData?.selectedCampaign || {};
      const webFormData = campaignLeadManagementData?.selectedForm || {};
      const localData = { campaign: campaignData, phoneNumber: phoneNumber, webForm: webFormData };
      const Id = rowData?.id;
      localStorage.setItem('leadWebFormData', JSON.stringify(localData));
      if (phoneNumber && isValidNumber(phoneNumber)) {
        const url = `/r/lead-web-form/${phoneNumber}/${Id}`;
        window.open(url, '_blank', 'noopener,noreferrer');
        // navigate(`/r/lead-web-form/${phoneNumber}/${rowData?.id}`);
      } else {
        showSnackBar('Phone number not available for this record.', 'error');
      }
    } catch (error) {
      showSnackBar(error?.toString() ?? 'Error navigating to web form.', 'error');
    }
  };

  const leadIdColumnName =
    filterableFields?.find((field) => field?.key_name === 'lead_id')?.alias_name ?? 'Id';
  const columns = useMemo(() => {
    const dynamicColumns =
      (filterableFields?.filter((f) => f?.access_level !== 'none') ?? []).map((field) => {
        // 1️⃣ Lead ID Column
        if (field?.key_name === 'lead_id') {
          return {
            accessorFn: (row) =>
              row?.data?.find((d) => d.key_name === field?.key_name)?.value ?? '',
            accessorKey: field?.key_name,
            id: field?.key_name,
            header: leadIdColumnName,
            Header: (
              <><EllipsisWithTooltip text={leadIdColumnName ?? ''} fontWeight={400} fontSize={14} maxWidth={100} /></>
            ),
            size: 120,
            minSize: 80,
            maxSize: 200,
            Cell: ({ cell, row }) => {
              const value = cell.getValue();
              return (
                // <Tooltip title={value} arrow placement="top">
                <Typography
                  variant="body2"
                  color="primary.main"
                  sx={{ cursor: 'pointer' }}
                  onClick={() => {
                    resetCampaignDataMap();
                    navigate(`/r/records/edit/${campaignId}/${leadFormId}/`, {
                      state: { parentLead: row?.original },
                    });
                  }}
                >
                  {/* {value} */}
                  <EllipsisWithTooltip text={value ?? ''} />
                </Typography>
                // </Tooltip>
              );
            },
            enableColumnActions: false,
          };
        }

        // 2️⃣ Phone Number Column
        if (field?.key_name === 'phone_number') {
          return {
            accessorKey: 'phone_number',
            header: "Contact Details",
            Header: (
              <><EllipsisWithTooltip text={'Contact Details'} fontWeight={400} fontSize={14} maxWidth={100} /></>
            ),
            Cell: ({ row }) => {
              const webFormPermission = constantActions.userHasPermission([
                globalpermissions?.pagePermissions?.webFormPageAccess,
              ]);
              return (
                <Typography
                  variant="body2"
                  color={webFormPermission ? 'primary.main' : 'text.primary'}
                  sx={{ cursor: 'pointer' }}
                  onClick={() => webFormPermission && navigateToWebForm(row?.original)}
                >
                  <EllipsisWithTooltip text={row?.original?.phone_number ?? ''} />
                </Typography>
              );
            },
            size: 150,
          };
        }

        // 3️⃣ Created At Column
        if (field?.key_name === 'created_at') {
          return {
            accessorKey: 'created_at',
            header: "Created",
            Header: (
              <><EllipsisWithTooltip text={'Created'} fontWeight={400} fontSize={14} maxWidth={100} /></>
            ),
            size: 140,
            Cell: ({ row }) => {
              const createdAt = row?.original?.created_at;
              return <>{createdAt ? indianTimeZone(createdAt).format('DD-MM-YYYY, h:mm A') : ''}</>;
            },
          };
        }

        // 4️⃣ Last Comment Column
        if (field?.key_name === 'last_machadalo_comment.comment') {
          return {
            accessorFn: (row) => row?.last_machadalo_comment?.comment ?? '',
            accessorKey: field?.key_name,
            header: 'Comment',
            Header: (
              <><EllipsisWithTooltip text={'Comment'} fontWeight={400} fontSize={14} maxWidth={100} /></>
            ),
            size: 200,
            enableSorting: false,
            enableColumnActions: false,
            Cell: ({ cell }) => <EllipsisWithTooltip text={cell?.getValue() ?? ''} />,
          };
        }

        // 5️⃣ Audio Summary Column
        if (field?.key_name === 'audio_summary') {
          return {
            accessorKey: 'audio_summary',
            header: "Summary",
            Header: (
              <><EllipsisWithTooltip text={'Summary'} fontWeight={400} fontSize={14} maxWidth={100} /></>
            ),
            size: 80,
            enableSorting: false,
            enableColumnActions: false,
            Cell: ({ row }) => {
              const hasTranscript = !!row.original?.audio_summary?.transcript;

              const handleClick = async () => {
                try {
                  const data = await aiActions.getLeadTranscript(row.original?.lead_id);
                  setDataList(data);
                  setSummaryRowData(row.original);
                  setOpenSummaryModal(true);
                } catch (err) {
                  console.error('Error fetching transcript');
                }
              };

              return (
                <Typography
                  variant="body2"
                  color="primary.main"
                  sx={{ cursor: 'pointer' }}
                  onClick={handleClick}
                >
                  {hasTranscript ? 'Upload' : 'View'}
                </Typography>
              );
            },
          };
        }

        // 6️⃣ AI Chat Column
        if (field?.key_name === 'aichat') {
          return {
            accessorKey: 'aichat',
            header: "AI Chat",
            Header: (
              <><EllipsisWithTooltip text={'AI Chat'} fontWeight={400} fontSize={14} maxWidth={100} /></>
            ),
            size: 80,
            enableSorting: false,
            enableColumnActions: false,
            Cell: ({ row }) => {
              const flowType = row.original.flow_type;
              const hasAIChatData =
                flowType === 'AI' || (row.original.aichat && row.original.aichat.length > 0);

              if (!hasAIChatData) return '-';

              return (
                <Typography
                  variant="body2"
                  color="primary.main"
                  sx={{ cursor: 'pointer' }}
                  onClick={() => handleOpenAIChatModal(row.original)}
                >
                  Chat
                </Typography>
              );
            },
          };
        }

        // 7️⃣ ENTITY Field
        // if (field?.key_type === 'ENTITY') {
        //   return {
        //     accessorFn: (row) =>
        //       row?.data?.find((d) => d.key_name === field?.key_name)?.value ?? '-',
        //     id: field?.key_name,
        //     accessorKey: field?.key_name,
        //     header: field?.alias_name ?? field?.key_name,
        //     Header: (
        //       <><EllipsisWithTooltip text={field?.alias_name} fontWeight={400} fontSize={14} maxWidth={100} /></>
        //     ),
        //     Cell: ({ cell }) => <EllipsisWithTooltip text={cell?.getValue()?.toString() ?? '-'} />,
        //   };
        // }

        // 7️⃣ ENTITY Field
        if (field?.key_type === 'ENTITY') {
          return {
            accessorFn: (row) =>
              row?.data?.find((d) => d.key_name === field?.key_name)?.value ?? '-',
            id: field?.key_name,
            accessorKey: field?.key_name,
            header: field?.alias_name ?? field?.key_name,
            Header: (
              <><EllipsisWithTooltip text={field?.alias_name} fontWeight={400} fontSize={14} maxWidth={100} /></>
            ),
            size: 200,
            enableSorting: false,
            enableColumnActions: false,
            Cell: ({ row }) => {
              const fieldData = row.original?.data?.find((d) => d.key_name === field.key_name);
              const entityData = fieldData?.entity_data;
              const currentValue = entityData
                ? { _id: entityData._id, value: entityData.value }
                : fieldData?.value
                  ? { _id: fieldData.value, value: fieldData.value }
                  : null;
              const queryParams = buildEntityQueryParamsForRow(field, row.original);

              return (
                <EntityDetailsDropdown
                  value={currentValue}
                  onChange={async (selectedOption) => {
                    try {
                      const prevData = row.original?.data ?? [];
                      const updatedData = prevData.map((item) => {
                        if (item?.key_name !== field.key_name) return item;
                        if (!selectedOption) {
                          return { ...item, value: '', entity_data: null };
                        }
                        return {
                          ...item,
                          value: selectedOption?._id ?? '',
                          entity_data: {
                            _id: selectedOption?._id ?? '',
                            value: selectedOption?.value ?? '',
                          },
                        };
                      });

                      setLeadActions({
                        type: 'update',
                        payload: { ...row.original, data: updatedData },
                      });

                      const payload = buildLeadPayloadForEntityUpdate(row.original, updatedData);
                      const res: any = await leadActions.updateLeadV1(payload);
                      if (res?.status === 200) {
                        showSnackBar('Entity updated successfully!', 'success');
                      } else {
                        showSnackBar('Failed to update entity.', 'error');
                        setLeadActions({
                          type: 'update',
                          payload: { ...row.original, data: prevData },
                        });
                      }
                    } catch (error) {
                      showSnackBar('Failed to update entity.', 'error');
                      setLeadActions({
                        type: 'update',
                        payload: { ...row.original, data: row.original?.data ?? [] },
                      });
                    }
                  }}
                  entityFormId={field?.entity?._id ?? ''}
                  label=""
                  disabled={field?.access_level === 'view'}
                  displayField="value"
                  selectedEntityFields={field?.selectedEntityFields ?? []}
                  queryParams={queryParams}
                  sx={{
                    mb: 0,
                    mt: 0,
                    minWidth: 130,
                    maxWidth: 200,
                    '& .MuiOutlinedInput-root': {
                      height: 28,
                      borderRadius: '999px',
                      fontSize: '0.75rem',
                      padding: '0 8px',
                      backgroundColor: 'transparent',
                      '& fieldset': {
                        borderColor: 'divider',
                        borderWidth: '0.5px',
                      },
                      '&:hover fieldset': {
                        borderColor: 'primary.main',
                      },
                    },
                    '& .MuiInputBase-input': {
                      padding: '0 4px',
                      fontSize: '0.75rem',
                      lineHeight: 1,
                    },
                    '& .MuiInputLabel-root': {
                      display: 'none',
                    },
                    '& .MuiAutocomplete-endAdornment': {
                      right: 4,
                    },
                  }}
                />
              );
            },
          };
        }
        // 8️⃣ FILE Field
        if (field?.key_type === 'FILE') {
          return {
            accessorFn: (row) =>
              row?.data?.find((d) => d.key_name === field?.key_name)?.value ?? null,
            id: field?.key_name,
            accessorKey: field?.key_name,
            header: field?.alias_name ?? field?.key_name,
            Header: (
              <><EllipsisWithTooltip text={field?.alias_name} fontWeight={400} fontSize={14} maxWidth={100} /></>
            ),
            Cell: ({ cell }) => {
              const value = cell.getValue();
              if (!value) return '-';

              if (typeof value === 'object' && value instanceof File) {
                return (
                  <Typography
                    variant="body2"
                    color="primary.main"
                    sx={{ cursor: 'pointer' }}
                    onClick={() => {
                      const url = URL.createObjectURL(value);
                      window.open(url, '_blank', 'noopener,noreferrer');
                    }}
                  >
                    View
                  </Typography>
                );
              }

              if (typeof value === 'string' && value.startsWith('https')) {
                return (
                  <Typography
                    variant="body2"
                    color="primary.main"
                    sx={{ cursor: 'pointer' }}
                    onClick={() => {
                      window.open(value, '_blank', 'noopener,noreferrer');
                    }}
                  >
                    View
                  </Typography>
                );
              }

              return <EllipsisWithTooltip text={value?.toString()} />;
            },
          };
        }

        // 9️⃣ DROPDOWN - Substatus
        if (field?.key_type === 'DROPDOWN' && field?.statusOption === 'is_sub_status') {
          return {
            accessorFn: (row) => row?.data?.find((d) => d.key_name === field?.key_name) ?? null,
            id: field?.key_name,
            accessorKey: field?.key_name,
            header: field?.alias_name ?? field?.key_name,
            Header: (
              <><EllipsisWithTooltip text={field?.alias_name} fontWeight={400} fontSize={14} maxWidth={100} /></>
            ),
            Cell: ({ row }) => {
              const fieldData = row.original?.data?.find((d) => d.key_name === field.key_name);
              const cfg = getParentStatusConfig(row?.original, field?.status_parent_key) ?? null;
              const optionsData =
                typeOfStatusList[field?.key_name]?.filter((s) => s?.status_id === cfg?.status_id) ??
                [];

              const currentValue = optionsData?.find(
                (s) => s?.sub_status_id === fieldData?.status_config?.sub_status_id
              ) ?? { name: 'Select' };

              return (
                <StatusDropdown
                  options={optionsData}
                  value={currentValue}
                  onChange={(selected) => {
                    setConfirmStatusOpen(true);
                    setStatusDataToUpdate({
                      id: row?.original?.id ?? '',
                      sub_status_name: selected?.name ?? '',
                      status_name: selected?.status_name || '',
                      status_id: selected?.status_id || '',
                      type_of_status: selected?.type_of_status ?? fieldData?.key_name ?? '',
                      sub_status_id: selected?.sub_status_id || '',
                    });
                    setSelectedRow({ ...row?.original });
                  }}
                  labelKey="name"
                  valueKey="sub_status_id"
                  disabled={field?.access_level === 'view'}
                />
              );
            },
          };
        }

        // 🔟 DROPDOWN - Status
        if (field?.key_type === 'DROPDOWN' && field?.statusOption === 'is_status') {
          return {
            accessorFn: (row) => row?.data?.find((d) => d.key_name === field?.key_name) ?? null,
            id: field?.key_name,
            accessorKey: field?.key_name,
            header: field?.alias_name ?? field?.key_name,
            Header: (
              <><EllipsisWithTooltip text={field?.alias_name} fontWeight={400} fontSize={14} maxWidth={100} /></>
            ),
            Cell: ({ row }) => {
              const fieldData = row.original?.data?.find((d) => d.key_name === field.key_name);
              const statusOptions = typeOfStatusList[field?.key_name] ?? [];
              const currentValue = statusOptions?.find(
                (s) => s?.status_id === fieldData?.status_config?.status_id
              ) ?? { status_name: 'Select' };

              return (
                <StatusDropdown
                  options={statusOptions}
                  value={currentValue}
                  onChange={(selected) => {
                    setConfirmStatusOpen(true);
                    setStatusDataToUpdate({
                      id: row?.original?.id,
                      status: selected?.status_name || '',
                      status_name: selected?.status_name || '',
                      status_id: selected?.status_id || '',
                      type_of_status: selected?.type_of_status || '',
                    });
                    setSelectedRow({ ...row?.original });
                  }}
                  labelKey="status_name"
                  valueKey="status_id"
                  disabled={field?.access_level === 'view'}
                />
              );
            },
          };
        }

        // 11️⃣ Default Field (TEXT, DATE, CHECKBOX, etc.)
        return {
          accessorFn: (row) => row?.data?.find((d) => d.key_name === field?.key_name)?.value ?? '-',
          id: field?.key_name,
          accessorKey: field?.key_name,
          header: field?.alias_name ?? field?.key_name,
          Header: (
            <><EllipsisWithTooltip text={field?.alias_name} fontWeight={400} fontSize={14} maxWidth={100} /></>
          ),
          Cell: ({ cell }) => {
            const value = cell.getValue();

            if (value == null || value === '') return '-';

            if (
              field?.data_type === 'DATE' ||
              (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}/.test(value))
            ) {
              return <EllipsisWithTooltip text={dateFormate(value, 'DD-MM-YYYY')} />;
            } else if (['DROPDOWN', 'RADIO', 'CHECKBOX'].includes(field?.key_type)) {
              const colorMap = optionColorsByAlias[field?.key_name] || {};
              const rawValues = Array.isArray(value)
                ? value
                : typeof value === 'string'
                  ? value
                    .split(',')
                    .map((v) => v.trim())
                    .filter(Boolean)
                  : [value];

              const values = rawValues
                .map((v) => (typeof v === 'object' ? (v.label ?? v.name ?? v.value) : v))
                .filter(Boolean);

              if (!values.length) return '-';

              return (
                <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
                  {values.map((val, i) => (
                    <CommonBadges
                      key={`${field.key_name}-${val}-${i}`}
                      value={<EllipsisWithTooltip text={val} />}
                      color={colorMap[val] || ''}
                    />
                  ))}
                </Box>
              );
            } else if (field?.key_type === 'TEXTAREA') {
              return <EllipsisWithTooltip text={value} />;
            }

            return (
              <EllipsisWithTooltip
                text={typeof value === 'object' ? JSON.stringify(value) : value.toString()}
              />
            );
          },
        };
      }) ?? [];

    return [
      ...dynamicColumns,
    ];
  }, [
    tableState,
    typeOfStatusList,
    leadIdColumnName,
    buildEntityQueryParamsForRow,
    buildLeadPayloadForEntityUpdate,
    leadActions,
    setLeadActions,
    showSnackBar,
  ]);

  const [columnVisibility, setColumnVisibility] = useState({});

  useEffect(() => {
    // if sorting applied -> fetch with sort params, else clear sort params and refetch initial data
    const currentFilters = tableState?.filters ?? {};
    if (sorting?.length > 0) {
      const firstSort = sorting[0];
      const { id, desc } = firstSort;
      const updatedFilters = {
        ...currentFilters,
        sort_by: id || 'created_at',
        sort_type: desc ? -1 : 1,
        offset: 0, // reset to first page when sort changes
      };
      fetchLeads(updatedFilters);
    } else {
      // clearing sorting: remove sort_by/sort_type and reset offset to get original ordering
      const { sort_by, sort_type, ...rest } = currentFilters;
      const updatedFilters = {
        ...rest,
        offset: 0,
      };
      fetchLeads(updatedFilters);
    }
  }, [sorting]);

  useEffect(() => {
    fetchLeads({ ...tableState.filters, offset: 0, search: debouncedSearch })
  }, [debouncedSearch, leadFormId]);

  const handleRowSelectionChange = (updater) => {
    try {
      const tableListData = tableState?.data ?? [];
      const prevRowSelection = Object.fromEntries(
        tableListData.map((lead) => [
          lead?.lead_id,
          !!selectedLeads?.[lead?.lead_id], // ✅ FIX: object lookup instead of .some
        ])
      );
      const newRowSelection = typeof updater === 'function' ? updater(prevRowSelection) : updater;
      const selected = tableListData.filter((lead) => newRowSelection?.[lead?.lead_id]);
      const selectedMap = Object.fromEntries(selected.map((lead) => [lead?.lead_id, true]));
      setSelectedLeads(selectedMap);
    } catch (err) {
      showSnackBar(err?.toString() ?? 'Error', 'error');
    }
  };

  const handleAddLead = () => {
    setOpenFormDetailModal(true);
    setSelectedRow(null);
  };

  useEffect(() => {
    const statusData: Record<string, any[]> = {};
    statusList?.forEach((item: any) => {
      if (item?.type_of_status) {
        if (!statusData[item.type_of_status]) {
          statusData[item.type_of_status] = [];
        }
        const { substatuses, ...rest } = item;
        statusData[item.type_of_status].push(rest);
      }
      item?.substatuses?.forEach((sub: any) => {
        const key = sub?.type_of_status || 'unknown';
        if (!statusData[key]) {
          statusData[key] = [];
        }
        statusData[key].push({
          ...sub,
          status_id: item?.status_id,
          status_name: item?.status_name,
        });
      });
    });
    setTypeOfStatusList(statusData);
  }, [statusList]);

  const [anchorEl, setAnchorEl] = useState(null);
  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const open = Boolean(anchorEl);
  const columnOrder = [
    'mrt-row-numbers',
    'mrt-row-select',
    'lead_id',
    'phone_number',
    'created_at',
    ...filterableFields
      ?.filter(f => !f?.is_static_column)  // exclude items where is_static_column is true
      ?.map(f => `${f?.key_name}`),
    'last_machadalo_comment.comment',
    'audio_summary',
    'aichat',
    'mrt-row-actions',
  ];

  const saveColumnVisibilitySettings = async () => {
    const columnVisibilityToSave = updateFormObjectForColumnVisibility(
      columnVisibility,
      campaignLeadManagementData?.selectedForm ?? {},
      loggedInUser?.id
    );
    try {
      const res = await leadActions.updateLeadForm(columnVisibilityToSave, leadFormId);
      if (res?.status === 200) {
        showSnackBar('Column visibility settings saved!', 'success');
        const localData = {
          campaign: campaignLeadManagementData?.selectedCampaign ?? {},
          webForm: columnVisibilityToSave,
        };
        localStorage.setItem('leadWebFormData', JSON.stringify(localData));
      }
    } catch (error) {
      showSnackBar('Failed to save column visibility settings', 'error');
    }
    handleClose();
  };

  const renderColumnToggles = (
    <Box p={2} minWidth={220} maxWidth={350}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
        <Typography variant="subtitle2" fontWeight={600} mb={1}>
          Display columns
        </Typography>
        <Button size="small" onClick={() => saveColumnVisibilitySettings()}>
          Save View
        </Button>
      </Box>

      {/* Master Checkbox */}
      <FormControlLabel
        control={
          <Checkbox
            size="small"
            indeterminate={
              Object.keys(columnVisibility).length > 0 &&
              Object.values(columnVisibility).some(Boolean) &&
              !Object.values(columnVisibility).every(Boolean)
            }
            checked={
              Object.keys(columnVisibility).length > 0 &&
              Object.values(columnVisibility).every(Boolean)
            }
            onChange={(e) => {
              const checked = e.target.checked;
              const updated = Object.keys(columnVisibility).reduce((acc, key) => {
                acc[key] = checked;
                return acc;
              }, {});
              setColumnVisibility(updated);
            }}
          />
        }
        label="All Columns"
        sx={{
          borderBottom: '1px solid #eee',
          width: '100%',
        }}
      />
      {/* Grid layout for checkboxes */}
      <Grid container spacing={0.5}>
        {columns.map((col) => (
          <Grid item xs={6} key={col.accessorKey}>
            <FormControlLabel
              key={col.accessorKey}
              control={
                <Checkbox
                  size="small"
                  checked={!!columnVisibility[col.accessorKey]}
                  onChange={(e) => {
                    const updated = {
                      ...columnVisibility,
                      [col.accessorKey]: e.target.checked,
                    };
                    setColumnVisibility(updated);
                  }}
                  sx={{
                    '& .MuiFormControlLabel-label': {
                      fontSize: '0.85rem',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    },
                  }}
                />
              }
              label={col?.header ?? ''}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );

  const renderDownloadModal = (
    <Box>

      {/* Applied Filters Section */}
      <Box mb={3} pb={2} sx={{ borderBottom: '1px solid #eee' }}>
        <Typography variant="subtitle2" fontWeight={600} mb={1.5}>
          Applied Filters
        </Typography>
        {hasActiveFilters ? (
          <Box sx={{ bgcolor: '#f5f5f5', p: 1.5, borderRadius: 1 }}>
            <Typography variant="body2" color="textSecondary">
              <strong>Date Range:</strong> {tableState?.filters?.start_date && tableState?.filters?.end_date
                ? `${tableState.filters.start_date} to ${tableState.filters.end_date}`
                : 'No date range selected'}
            </Typography>
            {/* {tableState?.filters?.dynamicFilters && tableState?.filters?.dynamicFilters?.length > 0 && (
              <Typography variant="body2" color="textSecondary" mt={1}>
                <strong>Dynamic Filters:</strong> {tableState.filters.dynamicFilters.length} filter(s) applied
              </Typography>
            )} */}
            {tableState?.filters?.search && (
              <Typography variant="body2" color="textSecondary" mt={1}>
                <strong>Search:</strong> "{tableState.filters.search}"
              </Typography>
            )}
          </Box>
        ) : (
          <Typography variant="body2" color="textSecondary" sx={{ fontStyle: 'italic' }}>
            No filters applied
          </Typography>
        )}
      </Box>
      <Box mb={2}>
        <Typography variant="subtitle2" fontWeight={600} mb={1.5}>
          Select Columns to Download
        </Typography>

        {/* Master Checkbox */}
        <FormControlLabel
          control={
            <Checkbox
              size="small"
              indeterminate={
                Object.keys(downloadColumnVisibility).length > 0 &&
                Object.values(downloadColumnVisibility).some(Boolean) &&
                !Object.values(downloadColumnVisibility).every(Boolean)
              }
              checked={
                Object.keys(downloadColumnVisibility).length > 0 &&
                Object.values(downloadColumnVisibility).every(Boolean)
              }
              onChange={(e) => {
                const checked = e.target.checked;
                const updated = Object.keys(downloadColumnVisibility).reduce((acc, key) => {
                  acc[key] = checked;
                  return acc;
                }, {});
                setDownloadColumnVisibility(updated);
              }}
            />
          }
          label="Select All"
          sx={{
            borderBottom: '1px solid #eee',
            width: '100%',
            mb: 1,
          }}
        />

        {/* Grid layout for checkboxes */}
        <Grid container spacing={1}>
          {columns?.filter(col => col.accessorKey !== 'audio_summary' && col.accessorKey !== 'aichat')?.map((col) => (
            <Grid item xs={3} key={col.accessorKey}>
              <FormControlLabel
                key={col.accessorKey}
                control={
                  <Checkbox
                    size="small"
                    checked={!!downloadColumnVisibility[col.accessorKey]}
                    onChange={(e) => {
                      const updated = {
                        ...downloadColumnVisibility,
                        [col.accessorKey]: e.target.checked,
                      };
                      setDownloadColumnVisibility(updated);
                    }}
                    sx={{
                      '& .MuiFormControlLabel-label': {
                        fontSize: '0.85rem',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                      },
                    }}
                  />
                }
                label={col?.header ?? ''}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );

  useEffect(() => {
    if (campaignLeadManagementData?.selectedForm) {
      const dynamicColumnVisibility = getColumnVisibilityFromFormObject(
        campaignLeadManagementData?.selectedForm,
        loggedInUser?.profile?.id
      );

      const defaultVisibilityObj = defaultVisibleColumns.reduce((acc, columnKey) => {
        acc[columnKey] = true;
        return acc;
      }, {});

      const mergedVisibility = {
        ...defaultVisibilityObj,
        ...dynamicColumnVisibility,
      };

      setColumnVisibility(mergedVisibility);
    }
  }, [campaignLeadManagementData?.selectedForm, loggedInUser?.profile?.id]);


  const fetchMoreOnBottomReached = useCallback(
    (containerRefElement?: HTMLDivElement | null) => {
      if (!containerRefElement) return;
      const { scrollHeight, scrollTop, clientHeight, scrollLeft } = containerRefElement;
      const prevScrollLeft = lastScrollLeftRef.current;
      const prevScrollTop = lastScrollTopRef.current;
      const horizontalOnly = scrollLeft !== prevScrollLeft && scrollTop === prevScrollTop;
      const isScrollingDown = scrollTop > prevScrollTop;
      lastScrollLeftRef.current = scrollLeft;
      lastScrollTopRef.current = scrollTop;
      if (horizontalOnly) return;
      if (!isScrollingDown) return;
      if (isLoading) return;
      const totalDBRowCount = tableState?.totalCount || 0;
      const totalFetched = tableState?.data?.length || 0;
      const scrollFraction = (scrollTop + clientHeight) / scrollHeight;
      if (
        scrollFraction >= 0.7 &&
        totalFetched < totalDBRowCount
        // scrollHeight === (scrollTop + clientHeight)   && fetchedData?.state !== 'loading' && totalFetched < totalDBRowCount
      ) {
        fetchLeads({ ...tableState?.filters, offset: totalFetched })
      }
    },
    [tableState, isLoading]
  );

  const rowVirtualizerInstanceRef = useRef<MRT_RowVirtualizer>(null);
  useEffect(() => {
    try {
      rowVirtualizerInstanceRef?.current?.scrollToIndex?.(0);
    } catch (error) {
      console.error(error);
    }
  }, [tableState?.filters?.sort_by, tableState?.filters?.sort_type, tableState?.filters?.search]);

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              p: '2px',
              flexWrap: { xs: 'wrap', sm: 'nowrap' },
              width: { xs: '100%', sm: '50%' },
            }}
          >
            <SearchBox
              value={searchInput ?? ''}
              handleSearch={(e: string) => setSearchInput(e)}
            />
            <Button
              variant="contained"
              size="small"
              startIcon={<AddCircleOutlineIcon />}
              onClick={handleAddLead}
            >
              Add
            </Button>
            {/* <Button
              color="error"
              disabled={!table.getIsSomeRowsSelected()}
              onClick={() => {
                alert('Delete Selected Accounts');
              }}
              variant="contained"
              size="small"
              >
              Delete
              </Button> */}

            <Stack
              direction="row"
              divider={<Divider orientation="vertical" flexItem />}
              spacing={2}
            >
              <Typography>
                {/* Fetched {tableState?.data?.length ?? 0} of{' '} */}
                Total records: {tableState?.totalCount || 0}
              </Typography>
              <Typography>
                Unique records: {tableState?.uniquePhoneCount || 0}
              </Typography>
            </Stack>
          </Box>
        </>
        <>
          <Box
            sx={{
              display: 'flex',
              gap: '0.5rem',
              p: '2px',
              width: { xs: '100%', sm: '50%' },
              justifyContent: 'end',
            }}
          >

            {/* <DateRangeFilter
              onApply={handleDateRangeApply}
              buttonLabel="Create At"
              startDate={dateRange.startDate}
              endDate={dateRange.endDate}
            /> */}

            <Box display="flex" justifyContent="flex-end">
              {renderToolTip(
                'Show/Hide Columns',
                <IconButton onClick={handleOpen} color="primary">
                  <VisibilityOffIcon fontSize="small" />
                </IconButton>
              )}
              <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
              >
                {renderColumnToggles}
              </Popover>
            </Box>
            {renderToolTip(
              'Filters',
              <IconButton
                onClick={(event) => setFiltersAnchorEl(event.currentTarget)}
                color={filtersAnchorEl || hasActiveFilters ? 'secondary' : 'primary'}
                sx={{
                  bgcolor: filtersAnchorEl || hasActiveFilters ? 'primary.main' : 'transparent',
                  '&:hover': {
                    bgcolor: filtersAnchorEl || hasActiveFilters ? 'primary.main' : 'transparent',
                  },
                  '& .MuiSvgIcon-root': {
                    color: filtersAnchorEl || hasActiveFilters ? 'white' : 'inherit',
                  },
                }}
              >
                <FilterListIcon fontSize="small" />
              </IconButton>
            )}
            <Popover
              open={Boolean(filtersAnchorEl)}
              anchorEl={filtersAnchorEl}
              onClose={() => setFiltersAnchorEl(null)}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              sx={{
                '& .MuiPopover-paper': {
                  width: 440,
                  maxHeight: '80vh',
                },
              }}
            >
              <DynamicFilters
                open={Boolean(filtersAnchorEl)}
                onClose={(filtersToApply) => { setFiltersAnchorEl(null); fetchLeads(filtersToApply) }}
                typeOfStatusList={typeOfStatusList}
              />
            </Popover>
            {renderToolTip(
              'Help',
              <IconButton
                onClick={async () => {
                  setOpenHelpModal(true);
                }}
                color="primary"
              >
                <HelpOutlineIcon fontSize="small" />
              </IconButton>
            )}
            {renderToolTip(
              'Refresh Data',
              <IconButton onClick={handleRefresh} color="primary">
                {isLoading ? <CircularProgress size={16} /> : <RefreshIcon fontSize="small" />}
              </IconButton>
            )}
            {renderToolTip(
              'Actions',
              <IconButton onClick={handleClick1} color="primary">
                <MoreVertIcon fontSize="small" />
              </IconButton>
            )}
          </Box>
          <Box>
            <Menu
              id="menu-action-1"
              anchorEl={anchorElAction1}
              open={actionOpen1}
              onClose={handleClose1}
            >
              <MenuItem
                onClick={() => {
                  handleClose1();
                  handleOpenDownloadModal();
                }}
              >
                <DownloadIcon fontSize="small" sx={{ mr: 1 }} />
                Download Records
              </MenuItem>
              <MenuItem
                onClick={() => {
                  if (campaignId) {
                    navigate(`/r/records/${campaignId}/enterLeads`);
                  }
                }}
              >
                <AddCircleOutlineIcon fontSize="small" sx={{ mr: 1 }} />
                Enter Records
              </MenuItem>
              <MenuItem onClick={() => handleImport()}>
                <UploadFileIcon fontSize="small" sx={{ mr: 1 }} />
                Import Records
              </MenuItem>
              {constantActions.userHasPermission([
                globalpermissions?.leadDashboard?.createWebForm,
              ]) && (
                  <MenuItem
                    onClick={() => {
                      navigate(`/r/records/${campaignId}/editForm/${leadFormId}`, {
                        state: {
                          leadFormData: campaignLeadManagementData?.selectedForm ?? null,
                        },
                      });
                    }}
                  >
                    <EditIcon fontSize="small" sx={{ mr: 1 }} />
                    Edit Form
                  </MenuItem>
                )}
              {constantActions.userHasPermission([globalpermissions?.leadFormPage?.report]) && (
                <MenuItem
                  onClick={() => {
                    setOpenReportsModal(true);
                  }}
                >
                  <AssessmentIcon fontSize="small" sx={{ mr: 1 }} />
                  Reports
                </MenuItem>
              )}
              {/* {constantActions.userHasPermission([globalpermissions?.leadFormPage?.analytics]) && (
                <MenuItem
                  onClick={() => {
                    setOpenAnalyticsModal(true);
                  }}
                >
                  <TrendingUpIcon fontSize="small" sx={{ mr: 1 }} />
                  Analytics
                </MenuItem>
              )} */}
            </Menu>
          </Box>
        </>
      </Box>
      {isLoading && <LinearProgress />}
      <ToolBar
        selectedCount={Object.keys(selectedLeads ?? {}).length}
        selectedLeadIds={selectedLeads}
        onClear={() => setSelectedLeads({})}
        selectedRow={selectedRowsData.length === 1 ? selectedRowsData[0] : selectedRowsData}
        dynamicFormFields={filterableFields}
        dynamicFormGroups={dynamicFormGroups}
        currentCampaignId={campaignId ?? tableState?.filters?.campaignId ?? ''}
        currentLeadFormId={leadFormId ?? tableState?.filters?.leadFormId ?? ''}
        parentLead={null}
        typeOfStatusList={typeOfStatusList}
      />

      <CommonTable
        columns={columns}
        data={tableState?.data || []}
        initialState={{
          columnPinning: {
            right: ['mrt-row-actions'],
            left: ['mrt-row-numbers', 'mrt-row-select'],
          },
          density: 'compact',
          columnVisibility: columnVisibility,
          columnOrder,
        }}
        state={{
          // isLoading: isLoading,
          // showAlertBanner: true,
          // showProgressBars: isLoading,
          sorting: sorting,
          rowSelection: selectedLeads ?? {},
          globalFilter: tableState?.filters?.search || '',
          columnVisibility,
          columnOrder,
        }}
        enableRowNumbers={true}
        muiTableContainerProps={{
          sx: {
            height: campaignFormCount > 1 ? 'calc(100vh - 230px)' : 'calc(100vh - 190px)',
            width: '100%',
            maxHeight: '600px',
          },
          ref: tableContainerRef,
          onScroll: (event: UIEvent<HTMLDivElement>) =>
            fetchMoreOnBottomReached(event.target as HTMLDivElement),
        }}
        // muiTableContainerProps={{ sx: { maxHeight: 'calc(100vh - 300px)', width: '100%' } }}
        enableTopToolbar={false}
        enableBottomToolbar={false}
        // renderBottomToolbar={() => <></>}
        enableColumnFilters={false}
        onSortingChange={setSorting}
        enableMultiRowSelection={true}
        enableRowSelection={true}
        enableColumnActions={false}
        // enableHiding={false}
        // onColumnVisibilityChange={setColumnVisibility}
        manualFiltering={false}
        onGlobalFilterChange={(search) => setSearchInput(search)}
        manualSorting={true}
        onRowSelectionChange={handleRowSelectionChange}
        // rowSelection={selectedLeads ?? {}}
        getRowId={(row) => row?.lead_id?.toString() || row?.id?.toString()}
        enableRowActions={true}
        enableRowVirtualization={true}
        rowVirtualizerInstanceRef={rowVirtualizerInstanceRef}
        renderRowActions={({ row }) => (
          <IconButton onClick={(e) => handleMenuOpen(e, row)}>
            <MoreVertIcon />
          </IconButton>
        )}
      />
      {isLoading && <LinearProgress />}
      <Menu
        id="row-action-menu"
        anchorEl={menuAnchorEl}
        open={Boolean(menuAnchorEl)}
        onClose={handleMenuClose}
        MenuListProps={{ 'aria-labelledby': 'row-action-button' }}
      >
        <MenuItem
          onClick={() => {
            setSelectedRow(menuRow);
            setOpenCommentModal(true);
            handleMenuClose();
          }}
        >
          <InsertCommentIcon fontSize="small" sx={{ mr: 1 }} />
          Add Comment
        </MenuItem>

        {loggedInUser?.is_superuser && (
          <MenuItem
            onClick={() => {
              setSelectedRow(menuRow);
              setOpenEditLeadModal(true);
              handleMenuClose();
            }}
          >
            <EditIcon fontSize="small" sx={{ mr: 1 }} />
            Manage Record
          </MenuItem>
        )}

        <MenuItem
          onClick={() => {
            setSelectedRow(menuRow);
            setOpenFormDetailModal(true);
            handleMenuClose();
          }}
        >
          <DescriptionIcon fontSize="small" sx={{ mr: 1 }} />
          Form Detail
        </MenuItem>

        <MenuItem
          onClick={() => {
            setSelectedRow(menuRow);
            setOpenUpdateStatusModal(true);
            handleMenuClose();
          }}
        >
          <AssessmentIcon fontSize="small" sx={{ mr: 1 }} />
          Status Logs
        </MenuItem>

        <MenuItem
          onClick={() => {
            setSelectedRow(menuRow);
            setOpenImageModal(true);
            handleMenuClose();
          }}
        >
          <UploadFileIcon fontSize="small" sx={{ mr: 1 }} />
          Images
        </MenuItem>

        {constantActions.userHasPermission([globalpermissions?.leadFormPage?.quickCall]) && (
          <MenuItem
            onClick={() => {
              setSelectedRow(menuRow);
              setShowCallingModal(true);
              handleMenuClose();
            }}
          >
            <PhoneIcon fontSize="small" sx={{ mr: 1 }} />
            Quick Call
          </MenuItem>
        )}

        {constantActions.userHasPermission([
          globalpermissions?.leadDashboard?.deleteLeadColumn,
        ]) && (
            <MenuItem
              onClick={() => {
                setSelectedRow(menuRow);
                setConfirmDeleteOpen(true);
                handleMenuClose();
              }}
            >
              <DeleteIcon fontSize="small" sx={{ mr: 1, color: 'error.main' }} />
              Delete
            </MenuItem>
          )}
      </Menu>

      {openCommentModal && (
        <ViewCommentModal
          open={openCommentModal}
          onClose={() => setOpenCommentModal(false)}
          selectedRow={selectedRow}
          onSaveComment={(comment, id) => {
            setLeadActions({
              type: "update", payload: {
                ...selectedRow,
                internal_comments: [
                  ...(selectedRow.internal_comments ?? []),
                  {
                    comment,
                    created_by: loggedInUser?.username ?? 'You',
                    created_at: new Date().toISOString(),
                  },
                ],
                last_machadalo_comment: {
                  comment,
                  created_by: loggedInUser?.username ?? 'You',
                  created_at: new Date().toISOString(),
                },
              }
            })
          }}
        />
      )}

      {openFormDetailModal && (
        <FormDetailsModal
          open={openFormDetailModal}
          onClose={(data, type) => onCloseFormFieldsModal(data, type)}
          selectedRow={selectedRow}
          dynamicFormFields={filterableFields}
          dynamicFormGroups={dynamicFormGroups}
          currentCampaignId={campaignId ?? tableState?.filters?.campaignId ?? ''}
          currentLeadFormId={leadFormId ?? tableState?.filters?.leadFormId ?? ''}
          parentLead={null}
        />
      )}

      {openImageModal && (
        <ViewImagesModal
          open={openImageModal}
          onClose={() => setOpenImageModal(false)}
          selectedRow={selectedRow}
          onSaveImage={(image, id) => {
            setLeadActions({
              type: "update", payload: {
                ...selectedRow,
                image_funnel: selectedRow?.image_funnel ? [...selectedRow?.image_funnel, image] : [image],
              }
            })
          }}
        />
      )}

      {openUpdateStatusModal && (
        <AllUpdateStatusModal
          open={openUpdateStatusModal}
          onClose={() => setOpenUpdateStatusModal(false)}
          selectedRow={selectedRow}
          leadFormId={leadFormId}
        />
      )}

      <ConfirmBox
        open={confirmStatusOpen}
        onClose={(confirmed) => {
          handleConfirmUpdate(confirmed);
          setConfirmStatusOpen(false);
        }}
        options={{
          title: `Update ${convertToReadableFormat(
            statusDataToUpdate?.type_of_status || 'Status'
          )}`,
          text: `Are you sure you want to update ${convertToReadableFormat(
            statusDataToUpdate?.type_of_status || 'Status'
          )}${statusDataToUpdate?.sub_status_name
            ? ` to "${statusDataToUpdate.sub_status_name}"?`
            : statusDataToUpdate?.status_name
              ? ` to "${statusDataToUpdate.status_name}"?`
              : '?'
            }`,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          confirmButtonColor: 'error',
          cancelButtonColor: 'default',
        }}
      />
      <ConfirmBox
        open={confirmDeleteOpen}
        onClose={(confirmed) => {
          confirmDeleteLead(confirmed);
          setConfirmDeleteOpen(false);
        }}
        options={{
          title: 'Delete Record',
          text: 'Are you sure you want to delete this record?',
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          confirmButtonColor: 'error',
          cancelButtonColor: 'default',
        }}
      />
      {showCallingModal && (
        <ModalForms
          show={showCallingModal}
          handleClose={() => setShowCallingModal(false)}
          modalBody={
            <CallingModal userDetails={{ phone_number: selectedRow?.phone_number || '' }} />
          }
          modalHeader="Quick Call"
          modalId="calling"
          size="sm"
        />
      )}
      <AIChatModal
        open={openAIChatModal}
        onClose={() => {
          setOpenAIChatModal(false);
          setSelectedLeadCId('');
        }}
        leadId={selectedLeadCId}
      />
      <AudioSummaryModal
        open={openSummaryModal}
        onClose={() => setOpenSummaryModal(false)}
        rowData={summaryRowData}
        setDataList={setDataList}
        dataList={dataList}
        setTableState={setTableState}
      />
      <AssignLeadsModal
        open={isLeadAssignModalOpen}
        onClose={() => {
          setIsLeadAssignModalOpen(false);
          setSelectedLeads({});
        }}
        selectedLeads={selectedLeads}
        campaignId={campaignId ?? ''}
        handleRefresh={handleRefresh}
      />
      <AssignLeadsModal
        open={unAssignModalOpen}
        onClose={() => {
          setUnAssignModalOpen(false);
        }}
        selectedLeads={null}
        selectedRow={selectedRow}
        campaignId={campaignId ?? ''}
        handleRefresh={handleRefresh}
      />
      <AssignmentLogsModal
        open={openAssignmentLogs}
        onClose={() => setOpenAssignmentLogs(false)}
        lead={selectedRow}
        assignments={assignmentLogsData}
      />
      <ManageActionModal
        open={openEditLeadModal}
        onClose={() => setOpenEditLeadModal(false)}
        lead={selectedRow}
      />
      {openHelpModal && (
        <ModalForms
          show={openHelpModal}
          handleClose={() => setOpenHelpModal(false)}
          modalBody={
            <Box sx={{ p: 2 }}>
              <HelpFile leadFormId={leadFormId} />
            </Box>
          }
          modalHeader="Help"
          modalId="help"
          size="lg"
        />
      )}
      {/* Reports Modal */}
      {openReportsModal && (
        <ModalForms
          show={openReportsModal}
          handleClose={() => setOpenReportsModal(false)}
          modalBody={
            <Box sx={{ p: 2 }}>
              <Reports />
            </Box>
          }
          modalHeader="Reports"
          modalId="reports"
          size="sm"
        />
      )}

      {/* Analytics Modal */}
      {/* {openAnalyticsModal && (
        <ModalForms
          show={openAnalyticsModal}
          handleClose={() => setOpenAnalyticsModal(false)}
          modalBody={
            <Box sx={{ p: 2 }}>
              <Analytics />
            </Box>
          }
          modalHeader="Analytics"
          modalId="analytics"
          size="lg"
        />
      )} */}
      {/* <DynamicFilters open={filtersOpen} onClose={() => setFiltersOpen(false)} /> */}

      {openDownloadModal && (
        <ModalForms
          show={openDownloadModal}
          handleClose={() => setOpenDownloadModal(false)}
          modalBody={
            <>
              {renderDownloadModal}
            </>
          }
          modalFooter={<Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end', mt: 3 }}>
            <Button
              variant="outlined"
              onClick={() => setOpenDownloadModal(false)}
              size='small'
            >
              Cancel
            </Button>
            <Button
              size='small'
              variant="contained"
              startIcon={<DownloadIcon />}
              onClick={handleDownloadLeads}
              disabled={!Object.values(downloadColumnVisibility).some(Boolean)}
            >
              Download Records
            </Button>
          </Box>
          }
          modalHeader="Download Records"
          modalId="download-leads"
          size="sm"
        />
      )}

    </>
  );
};

export default LeadList;
